module.exports = __webpack_public_path__ + "static/wash_card_img1@2x-6abf5d5d0814b0ad3a88e085bc1d2792.jpg";